import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { Pc003Service } from '../../service/pc003.service';
import { FormularioService } from 'src/app/services/formulario.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ImportPc003ModalComponent } from 'src/app/shared/import-pc003/import-pc003.component';
import { MatDialog } from '@angular/material/dialog';
import { FilterDetailComponent } from 'src/app/shared/filter-detail/filter-detail.component';

@Component({
  selector: 'app-list-pc003',
  templateUrl: './list-pc003.component.html',
  styleUrls: ['./list-pc003.component.scss']
})
export class ListPc003Component implements OnInit {

  public displayedColumns?: string[] = [
    '#',
    'ContratoJuridico',
    'Hibrido',
    'Especie',
    'Safra',
    'Ano',
    'Geracao',
    'SiteOrigem',
    'Ações',
  ];

  isRemoveEnable = false;
  listData = [];
  rowsSelected: any[] = [];
  adm: boolean = false;
  public pageSizeOptions?: number[] = [];
  public dataSource?: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;


  @ViewChild(FilterDetailComponent, { static: false }) filterDetailComponent: FilterDetailComponent;

  constructor(private service: Pc003Service, private router: Router, private notificationService: NotificationService, protected formularioService: FormularioService, public dialog: MatDialog) {

    this.pageSizeOptions = this.formularioService.pageSizeOptions;
  }

  ngOnInit(): void {

    this.getUserPermission()

  }

  getUserPermission = async () => {
    await this.service.userIsAdmin().subscribe(adm => {
      if (adm) {
        this.adm = true;
        this.getList()
      }

    })
  }
  getList() {
    this.service.getListPc003(null)
      .then(res => {
        this.configDataTable(res?.data);
      })
      .catch(err => {
        console.error(err);
      })
  }

  showFilter() {
    this.filterDetailComponent.showMenu(true);
  }

  configDataTable(lista: Array<any>): void {
    this.dataSource = new MatTableDataSource(lista);
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator._intl.firstPageLabel = this.formularioService.firstPageLabel;
    this.dataSource.paginator._intl.lastPageLabel = this.formularioService.lastPageLabel;
    this.dataSource.paginator._intl.itemsPerPageLabel = this.formularioService.itemsPerPageLabel;
    this.dataSource.paginator._intl.nextPageLabel = this.formularioService.nextPageLabel;
    this.dataSource.paginator._intl.previousPageLabel = this.formularioService.previousPageLabel;
    // tslint:disable-next-line: max-line-length
    this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) { return `0 de ${length}`; }
      length = Math.max(length, 0); const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length)
        // tslint:disable-next-line: align
        : startIndex + pageSize; return `${startIndex + 1} – ${endIndex} de ${length}`;
    };
  }

  new() {
    this.router.navigateByUrl('adm/pc003/new/0');
  }

  edit(id) {
    this.router.navigateByUrl(`adm/pc003/new/${id}`);
  }

  importCsv(): void {
    this.dialog.open(ImportPc003ModalComponent);
  }

  selectItens(row) {
    if (this.rowsSelected.find(x => x === row.id) > 0) {
      this.rowsSelected = this.rowsSelected.filter(x => x !== row.id);
    }
    else {
      this.rowsSelected.push(row.id);
    }

    this.isRemoveEnable = this.rowsSelected.length > 0;

  }

  deleteMultiple() {
    this.service.remove(this.rowsSelected).then(result => {
      this.getList();
    })
  }

  delete(id) {
    this.service.remove([id]).then(result => {
      this.getList();
    })
  }

  getFilter(event) {
    this.service.getListPc003(event)
      .then(res => {
        this.configDataTable(res?.data);
      })
      .catch(err => {
        console.error(err);
      })
  }
}
